<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <div class="person_group__info__pre-header">
            <div class="d-flex align-center pa-2">
              <v-btn class="secondary--text mr-3" @click="goBack()" icon>
                <v-icon> mdi-arrow-left </v-icon>
              </v-btn>
              <v-divider vertical></v-divider>
              <h4 class="secondary--text font-weight-bold ml-6">
                {{
                  $t(
                    'fleet_management.person_groups.new_person_group.labels.card_title'
                  )
                }}
              </h4>
            </div>
          </div>
          <v-form ref="form" v-model="valid" v-if="showForm">
            <v-container class="px-8 py-6">
              <v-row>
                <v-col cols="12">
                  <v-row class="mt-3">
                    <v-col class="" cols="3">
                      <div class="tertiary--text text-body-2">
                        {{
                          $t(
                            'fleet_management.person_groups.person_group_info.labels.card_field_label'
                          )
                        }}
                      </div>
                      <v-text-field
                        v-model="personGroupLabel"
                        filled
                        dense
                        required
                        color="tertiary"
                        :rules="nameRules"
                        :error-messages="errorName"
                        :disabled="loading"
                        @input="waitAndSearchPersonGroups"
                        counter="30"
                        hide-details="auto"
                        id="idGruposDePersonasNombreCrear"
                      ></v-text-field>
                    </v-col>
                    <v-col sm="6">
                      <div class="tertiary--text text-body-2">
                        {{
                          $t(
                            'fleet_management.tags.tag_info.labels.card_field_color'
                          )
                        }}
                      </div>
                      <v-color-picker
                        v-model="personGroupColor"
                        dot-size="23"
                        hide-canvas
                        hide-inputs
                        hide-mode-switch
                        hide-sliders
                        mode="hexa"
                        show-swatches
                        swatches-max-height="100"
                        :disabled="loading"
                        :error="!selectpersonGroupColor"
                        error-messages="Debe seleccionar un color"
                        ref="colorPickerRef"
                      ></v-color-picker>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <hr class="divider-dotted" />
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="12" md="8" lg="6">
                  <div class="tertiary--text text-body-2">
                    {{
                      $t(
                        'fleet_management.person_groups.new_person_group.labels.card_created_persons'
                      )
                    }}
                  </div>
                  <v-autocomplete
                    v-model="selectedPersons"
                    return-object
                    filled
                    dense
                    :items="persons"
                    multiple
                    chips
                    deletable-chips
                    item-text="label"
                    no-data-text="no hay info"
                    :loading="personsLoading"
                    :disabled="loading || personsLoading"
                    color="tertiary"
                    id="idGruposDePersonasCrearPersonas"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item
                        id="idGruposDePersonasSeleccionarTodo"
                        ripple
                        @click="selectAllPersons()"
                      >
                        <v-list-item-action>
                          <v-icon>
                            {{ iconPersons }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{
                              $t(
                                'fleet_management.person_groups.new_person_group.labels.form_title_select_all'
                              )
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:item="data">
                      <v-checkbox
                        v-model="data.item.checked"
                        :value="data.item.checked"
                      ></v-checkbox>
                      <span
                        :id="
                          `idGruposDePersonasCrearPersona${persons.indexOf(
                            data.item
                          )}`
                        "
                        class="dropdown-element-style py-6"
                        @click="data.item.checked = !data.item.checked"
                      >
                        {{ data.item.label }}
                      </span>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 3">
                        <span>{{ item.label }}</span>
                      </v-chip>
                      <span v-else-if="index === 3" class="grey--text caption">
                        (+{{ selectedPersons.length - 3 }})
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row justify="space-between" class="footer">
                <v-col cols="auto">
                  <v-btn
                    id="idBtnGruposDePersonasCancelar"
                    outlined="true"
                    color="secondary"
                    rounded
                    @click="cancel()"
                    :disabled="loading"
                    :loading="loading"
                    >{{
                      $t(
                        'fleet_management.persons.person_info.labels.card_edit_person_cancel_button'
                      )
                    }}</v-btn
                  >
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    id="idBtnGruposDePersonasGuardar"
                    class="ml-2"
                    color="tertiary white--text"
                    rounded
                    @click="createPersonGroupMethod()"
                    :disabled="!valid || loading"
                    :loading="loading"
                    >{{
                      $t(
                        'fleet_management.persons.person_info.labels.card_edit_person_save_button'
                      )
                    }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <div v-else>
            <v-row>
              <v-col cols="12">
                <h2 class="secondary--text text-center mt-9">
                  {{
                    $t(
                      'fleet_management.person_groups.new_person_group.alerts.creation_success'
                    )
                  }}
                </h2>
              </v-col>
              <v-col>
                <h4 class="secondary--text text-center">
                  {{ personGroupLabel }}
                </h4>
              </v-col>
              <v-col cols="12" class="d-flex justify-center px-7 my-16">
                <v-btn
                  outlined="true"
                  color="secondary"
                  rounded
                  :to="{
                    name: 'PersonGroupDetail',
                    params: { id: tagId }
                  }"
                  >{{
                    $t(
                      'fleet_management.person_groups.new_person_group.labels.card_created_action_detail_button'
                    )
                  }}</v-btn
                >
                <v-btn
                  class="ml-2"
                  color="tertiary white--text"
                  rounded
                  @click="goBack()"
                  >{{
                    $t(
                      'fleet_management.person_groups.new_person_group.labels.card_created_action_list_button'
                    )
                  }}</v-btn
                >
              </v-col>
            </v-row>
          </div>
          <v-snackbar
            v-model="snack"
            :color="snackColor"
            :timeout="snackBarTimeout"
          >
            {{ snackText }}
            <template v-slot:action="{ attrs }">
              <v-btn v-bind="attrs" text @click="snack = false">
                {{
                  $t(
                    'fleet_management.persons.person_info.labels.card_snackbar_close_button'
                  )
                }}
              </v-btn>
            </template>
          </v-snackbar>
        </v-card>
        <Dialog
          :showDialog="showDialog"
          :text="dialog.text"
          :closeButtonText="dialog.closeButtonText"
          @cancelButtonPressed="showDialog = false"
          :submitButtonText="dialog.acceptButtonText"
          @submitButtonPressed="goBack"
          :type="dialog.type"
          :loading="dialog.loading"
          :oneButton="dialog.oneButtonDialog"
          :oneButtonText="dialog.oneButtonText"
          @oneButtonAction="cancelDialog"
        >
          <template v-slot:extra-data v-if="repeatTagName">
            "{{ repeatTagName.label }}"
          </template>
        </Dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { SvgIcon, SNACKBAR_TIMEOUT } from '@leapsight/styleguide'
import { mapGetters, mapActions, mapState } from 'vuex'
import { i18n } from '@leapsight/portal'
import Dialog from '@/components/dialog/Dialog'
import {
  TagsHelpers,
  PersonsHelpers
} from '@/helpers/mainExports'

export default {
  name: 'TagDetail',
  components: {
    SvgIcon,
    Dialog
  },
  data() {
    return {
      personsLoading: false,
      persons: [],
      selectedPersons: [],
      nameRules: [
        v => !!v || i18n.t('fleet_management.tags.tag_info.rules.required'),
        v =>
          (v && v.length >= 2 && v.length <= 30) ||
          i18n.t('fleet_management.tags.tag_info.rules.character_length'),
        v =>
          /^[A-Za-z0-9Ññáéíóú\s]+$/.test(v) ||
          i18n.t(
            'fleet_management.tags.tag_info.rules.only_alphanumeric_character'
          )
      ],
      personGroupLabel: '',
      personGroupColor: '',
      selectpersonGroupColor: null,
      snackText: '',
      snackColor: '',
      loading: false,
      errorMessage: '',
      dialogDefault: {
        text: '',
        closeButtonText: i18n.t('general.dialogComponent.closeButtonText'),
        acceptButtonText: i18n.t('general.dialogComponent.acceptButtonText'),
        type: '',
        loading: false,
        oneButtonDialog: false,
        oneButtonText: ''
      },
      dialog: {
        text: '',
        type: '',
        loading: false,
        oneButtonDialog: false,
        oneButtonText: ''
      },
      dialogName: false,
      showDialog: false,
      showForm: true,
      snack: false,
      snackBarTimeout: SNACKBAR_TIMEOUT,
      valid: true,
      setTime: null,
      cancelSubmit: false,
      errorName: '',
      repeatTagName: ''
    }
  },
  methods: {
    ...mapActions('tags', [
      'createTag',
      'setPersonsTag',
      'getTagsList'
    ]),
    ...mapActions('persons', ['getPersonsList']),
    cancelDialog() {
      this.showDialog = false
      Object.assign(this.dialog, this.dialogDefault)
    },
    cancel() {
      this.showDialog = true
      this.dialog.type = 'warning'
      this.dialog.text = i18n.t(
        'fleet_management.person_groups.new_person_group.alerts.data_confirmation'
      )
      this.dialog.closeButtonText = i18n.t(
        'fleet_management.geofences.create_geofence.alerts.card_cancel_button'
      )
      this.dialog.acceptButtonText = i18n.t(
        'fleet_management.geofences.create_geofence.alerts.card_accept_button'
      )
    },
    selectAllPersons() {
      if (this.selectedAllPersons) {
        this.selectedPersons.forEach(element => {
          element.checked = false
        });
        this.selectedPersons = []
      } else {
        this.selectedPersons = this.persons
        this.selectedPersons.forEach(element => {
          element.checked = true
        });
      }
    },
    goBack() {
      this.$router.push({ name: 'PersonGroups' })
    },
    async createPersonGroupMethod() {
      this.loading = true
      this.snack = false
      try {
        const newGroup = {
          label: this.personGroupLabel,
          color: this.personGroupColor,
          type: "person"
        }
        const { id } = await this.createTag(newGroup)

        if (this.selectedPersons.length > 0) {
          await this.setPersonsTag({
            tagId: id,
            persons: { added: this.selectedPersons, removed: [] }
          })
        }

        const data = await this.getTagsList()
        TagsHelpers.setTagsInLocalStorage(data)

        this.snackText = i18n.t(
          'fleet_management.person_groups.new_person_group.alerts.creation_success'
        )
        this.showForm = false
      } catch (e) {
        this.snackText = this.getResponseMessage
      } finally {
        this.loading = false
        this.snackColor = this.getSnackColor
        this.snack = true
      }
    },
    async getPersons() {
      try {
        this.personsLoading = true
        const response = await PersonsHelpers.getPersonsList({_p: 'id, first_name, last_name' })
        if (Boolean(response.args[0])) {
          this.persons = response.args[0].map(person => ({
            label: person.first_name + ' ' + person.last_name,
            id: person.id
          }))
        }
      } catch (e) {
        this.snackText = i18n.t(
          'fleet_management.person_groups.new_person_group.errors.error_loading_persons'
        )
        this.snackColor = 'error'
        this.snack = true
      } finally {
        this.personsLoading = false
      }
    },
    waitAndSearchPersonGroups() {
      // Espera 500ms y ejecuta la funcion checkName
      this.cancelSubmit = false
      clearTimeout(this.setTime)
      this.setTime = setTimeout(() => {
        this.checkName()
      }, 500)
    },
    checkName() {
      const name = this.personGroupLabel
      if (this.getTags.length > 0) {
        const tags = this.getTags
        for (let index = 0; index < tags.length; index++) {
          const element = tags[index]
          if (element.label === name) {
            this.repeatTagName = element
            this.showDialog = true
            this.dialog.type = 'warning'
            this.dialog.text = i18n.t(
              'fleet_management.tags.tag_info.errors.agent_match'
            )
            this.dialog.oneButtonDialog = true
            this.dialog.oneButtonText = i18n.t(
              'general.dialogComponent.acceptButtonText'
            )
            this.errorName = i18n.t(
              'fleet_management.tags.tag_info.errors.name_duplicated'
            )
            this.cancelSubmit = true
            break
          } else this.errorName = ''
        }
      }
    },
    setIdForColorPicker() {
      const elements = this.$refs.colorPickerRef
      const divs = elements.$el.getElementsByClassName('v-color-picker__color')
      divs.forEach((div, idx) => {
        div.id = `idGruposDePersonasColor${idx}`
      })
    }
  },
  computed: {
    ...mapGetters('auth', ['session']),
    ...mapGetters('tags', [
      'getCurrentTag',
      'getResponseMessage',
      'getResponseError',
      'getTags'
    ]),
    selectedAllPersons() {
      return this.selectedPersons.length === this.persons.length
    },
    selectedSomePersons() {
      return this.selectedPersons.length > 0 && !this.selectedAllPersons
    },
    iconPersons() {
      if (this.selectedAllPersons) return 'mdi-close-box'
      if (this.selectedSomePersons) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    tagId() {
      return this.getCurrentTag.id
    },
    getSnackColor() {
      return this.getResponseError ? 'error' : 'success'
    }
  },
  watch: {
    async session(value) {
      if (value.isOpen) {
        await this.getPersons()
      }
    }
  },
  mounted() {
    this.setIdForColorPicker()
  },
  async created() {
    if (this.session.isOpen) {
      await this.getPersons()
    }
  }
}
</script>

<style lang="scss" scoped>
.person_group__info__pre-header {
  border-bottom: 1px solid var(--pale-sky-blue);
}
.service-columns {
  min-width: 20%;
  max-width: 20%;
}
.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.divider-dotted {
  border-width: 0;
  background-size: 6px 3px;
  background-repeat: repeat-x;
  background-position-y: bottom;
  background-image: radial-gradient(
    circle,
    rgba(0, 0, 0, 0.15) 0.05rem,
    transparent 1.5px
  );
  height: 3px;
}
.dropdown-element-style {
  color: #2b2b2b;
  font-family: Lato, sans-serif;
  font-size: 13px;
  width: 100%;
}
</style>
